export default __webpack_public_path__ + "static/media/052-coin-1.8c7a7e83.svg";